// =============================================================================
// usercentrics module
// =============================================================================

const updateEvent = new CustomEvent("asuc-updated");
const data = {
  v: null,
  services: {},
  consent: {},
};

const checkUcVersion = () => {
  if (typeof usercentrics !== "undefined") {
    data.v = 1;
  } else if (typeof __ucCmp !== "undefined") {
    data.v = 3;
  } else if (typeof UC_UI !== "undefined") {
    data.v = 2;
  }
};

export const getUcData = async () => {
  if (data.v === 3) {
    await __ucCmp.getConsentDetails().then((response) => {
      // console.log(response);
      data.consent = response.consent;
      data.services = response.services;
    });
  }
};

export const getUcService = (id) => {
  if (data.v === 1) {
    // return usercentrics.getConsent(id);
  } else if (data.v === 2) {
    let s = UC_UI.getServicesBaseInfo().find((data) => data.id === id);
    return s && s.consent.status ? true : false;
  } else if (data.v === 3) {
    return data.services[id]?.consent?.given;
  }
};

export const checkUcInit = async () => {
  let isInitialized = false;

  if (data.v === 1) {
    // return usercentrics.getConsent(id);
  } else if (data.v === 2) {
    if (window.UC_UI && window.UC_UI.isInitialized()) {
      isInitialized = true;
    }
  } else if (data.v === 3) {
    isInitialized = await __ucCmp.isInitialized();
  }

  return isInitialized;
};

export const acceptUcService = async (id) => {
  checkUcVersion();

  if (data.v === 1) {
    usercentrics.updateConsents([{ templateId: id, status: true }]);
  } else if (data.v === 2) {
    UC_UI.acceptService(id);

    document.dispatchEvent(updateEvent);
  } else if (data.v === 3) {
    let service = data.services[id];

    if (service !== undefined) {
      let serviceConsents = [{ id: id, consent: true }];
      await __ucCmp.updateServicesConsents(serviceConsents);
      await __ucCmp.saveConsents();
      await __ucCmp.refreshScripts();
      await getUcData();

      document.dispatchEvent(updateEvent);
    }
  }
};

export const init = () => {
  checkUcVersion();
  getUcData();

  let acceptBtns = document.querySelectorAll(".asuc-accept");
  acceptBtns.forEach((btn) => {
    btn.addEventListener("click", async () => {
      await acceptUcService(btn.dataset.id);
    });
  });

  let attempts = 0;
  const whenComplete = async () => {
    checkUcVersion();
    if (++attempts > 30) return;
    if (await checkUcInit()) {
      document.dispatchEvent(updateEvent);

      if (data.v === 2) {
        window.addEventListener("ucEvent", function (event) {
          getUcData();
          document.dispatchEvent(updateEvent);
        });
        window.addEventListener("UC_UI_CMP_EVENT", function (event) {
          getUcData();
          document.dispatchEvent(updateEvent);
        });
      } else if (data.v === 3) {
        window.addEventListener("UC_CONSENT", function (event) {
          getUcData();
          document.dispatchEvent(updateEvent);
        });
      }
    } else {
      setTimeout(() => whenComplete(), 500);
    }
  };
  whenComplete();
};
